export default async function exportPDF() {
	window.print()
}
